import request from '@/utils/request'

let ProductApi = {

  /*分类管理*/
  catList (data, errorback) {
    return request._post('/supplier/product/category/index', data, errorback)
  },
  /*分类添加*/
  catAdd (data, errorback) {
    return request._postBody('/supplier/product/category/add', data, errorback)
  },
  /*分类删除*/
  catDel (data, errorback) {
    return request._post('/supplier/product/category/delete', data, errorback)
  },
  /*分类修改*/
  catEdit (data, errorback) {
    return request._postBody('/supplier/product/category/edit', data, errorback)
  },
  // /*产品列表*/
  // productList (data, errorback) {
  //   return request._postBody('/supplier/product/product/index', data, errorback);
  // },
  /*产品列表*/
  productList (data, errorback) {
    return request._postBody('/supplier/product/product/ProductIndex', data, errorback)
  },
  /*产品选择列表*/
  chooseLists (data, errorback) {
    //return request._postBody('/supplier/product/product/index', data, errorback);
    return request._postBody('/supplier/data/product/lists', data, errorback)
  },
  getProductStoreList (data, errorback) {
    //return request._postBody('/supplier/product/product/index', data, errorback);
    return request._postBody('/supplier/data/product/store/lists', data, errorback)
  },

  updateStoreNum (data, errorback) {
    return request._postBody('/supplier/data/product/store/edit', data, errorback)
  },

  updateProductSpeStatus (data, errorback) {
    return request._post('/supplier/data/product/update/spec/status', data, errorback)
  },

  /*产品选择列表*/
  supplierLists (data, errorback) {
    //return request._postBody('/supplier/product/product/index', data, errorback);
    return request._postBody('/supplier/product/product/ProductIndex', data, errorback)
  },
  /*规格选择列表*/
  chooseSpec (data, errorback) {
    return request._post('/supplier/data/product/spec', data, errorback)
  },
  /*新增产品*/
  addProduct (data, errorback) {
    return request._postBody('/supplier/product/product/add', data, errorback)
  },
  /*产品基础数据*/
  getBaseData (data, errorback) {
    return request._get('/supplier/product/product/toAdd', data, errorback)
  },
  /*删除产品*/
  delProduct (data, errorback) {
    return request._post('/supplier/product/product/delete', data, errorback)
  },
  /*产品基础数据*/
  getEditData (data, errorback) {
    return request._get('/supplier/product/product/edit', data, errorback)
  },
  /*新增产品*/
  editProduct (data, errorback) {
    return request._postBody('/supplier/product/product/edit', data, errorback)
  },
  /*新增规格组*/
  addSpec (data, errorback) {
    return request._post('/supplier/product/spec/addSpec', data, errorback)
  },
  /*新增规格值*/
  addSpecValue (data, errorback) {
    return request._post('/supplier/product/spec/addSpecValue', data, errorback)
  },
  /*商品列表不带分页*/
  getList (data, errorback) {
    return request._post('/supplier/data/product/lists', data, errorback)
  },
  /*商品列表不带分页*/
  getActiveProductList (data, errorback) {
    return request._post('/supplier/plus.fans.product/lists', data, errorback)
  },
  /*商品应用技术列表*/
  getTechnologyList (data, errorback) {
    return request._postBody('/supplier/product/technology/index', data, errorback)
  },
  addProductTechnology (data, errorBack) {
    return request._postBody('/supplier/product/technology/add', data, errorBack)
  },
  editProductTechnology (data, errorBack) {
    return request._postBody('/supplier/product/technology/edit', data, errorBack)
  },
  getTechnologyDetail (data, errorback) {
    return request._post('/supplier/product/technology/detail', data, errorback)
  },
  delTechnology (data, errorback) {
    return request._post('/supplier/product/technology/delete', data, errorback)
  },
  /*商品评论列表*/
  getCommentList (data, errorback) {
    return request._postBody('/supplier/product/comment/index', data, errorback)
  },
  /*获取评论详情*/
  getComment (data, errorback) {
    return request._post('/supplier/product/comment/detail', data, errorback)
  },
  /*获取评论详情*/
  editComment (data, errorback) {
    return request._postBody('/supplier/product/comment/edit', data, errorback)
  },
  /*删除评论*/
  delComment (data, errorback) {
    return request._post('/supplier/product/comment/delete', data, errorback)
  },
  /*得到分类图片*/
  cateImage (data, errorback) {
    return request._post('/supplier/product.category/image', data, errorback)
  },
  /*修改状态*/
  changeStatus (data, errorback) {
    return request._post('/supplier/product/product/state', data, errorback)
  },
  changeSpecsStatus (data, errorback) {
    return request._post('/supplier/product/product/spec/state', data, errorback)
  },
  /*供应商新增产品*/
  addSupplierProduct (data, errorback) {
    return request._postBody('/supplier/product/product/addProduct', data, errorback)
  },
  /*供应商商品列表*/
  supplierProductList (data, errorback) {
    return request._postBody('/supplier/product/product/index', data, errorback)
  },
  /*供应商代理销售商品列表*/
  supplierConsignmentProductList (data, errorback) {
    return request._postBody('/supplier/product/product/ProductIndex', data, errorback)
  },
  /*供应商所有商品列表*/
  supplierAllProductList (data, errorback) {
    return request._postBody('/supplier/product/product/all/index', data, errorback)
  },

  /*删除供应商产品*/
  supplierDeleteProduct (data, errorBack) {
    return request._postBody('/supplier/product/product/deleteProduct', data, errorBack)
  },
  /*删除供应商代销产品*/
  supplierDeleteConsignmentProduct (data, errorBack) {
    return request._postBody('/supplier/product/product/deleteConsignmentProduct', data, errorBack)
  },

  supplierPresaleList (data, errorback) {
    return request._postBody('/supplier/product/product/presale/index', data, errorback)
  },
  addsupplierPresale (data, errorback) {
    return request._postBody('/supplier/product/product/presale/edit', data, errorback)
  },
  delSupplierPresale (data, errorBack) {
    return request._post('/supplier/product/product/presale/delete', data, errorBack)
  },
  deliverySettingList (data, errorback) {
    return request._postBody('/supplier/product/product/delivery/list', data, errorback)
  },
  addDeliverySetting (data, errorback) {
    return request._postBody('/supplier/product/product/delivery/edit', data, errorback)
  },
  delDeliverySetting (data, errorBack) {
    return request._post('/supplier/product/product/delivery/delete', data, errorBack)
  },

  /*商品使用方法列表*/
  getUsageList (data, errorback) {
    return request._postBody('/supplier/product/usage/index', data, errorback)
  },
  addProductUsage (data, errorBack) {
    return request._postBody('/supplier/product/usage/add', data, errorBack)
  },
  editProductUsage (data, errorBack) {
    return request._postBody('/supplier/product/usage/edit', data, errorBack)
  },
  getUsageDetail (data, errorback) {
    return request._post('/supplier/product/usage/detail', data, errorback)
  },
  delUsage (data, errorback) {
    return request._post('/supplier/product/usage/delete', data, errorback)
  },
  /*分类管理*/
  cropList (data, errorback) {
    return request._post('/supplier/product/usage/crop/index', data, errorback)
  },
  //初始化商品价格
  uploadExcelFile (formData, errorback) {
    return request._upload('/supplier/excel/import/product/price', formData, errorback)
  },
}

export default ProductApi



// WEBPACK FOOTER //
// ./src/api/product.js